<template>
  <div class="bg p-3  mb-auto h-full overflow-auto bg-gradient-to-b  bg-gray-800" id="style-1">
      <div>asdddd</div>
  </div>
</template>


<style scoped>
.bg {
background: url('https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/bg%2Fmanagerroom.png?alt=media&token=6b9348b6-9364-4ce5-bf58-6e7b9c5b12f1') no-repeat center center fixed,
            linear-gradient(to bottom, rgba(31, 41, 55, 0.8), rgba(0, 0, 0, 0.9));
background-size: cover;
}
</style>